import { PropsWithChildren } from 'react';
import css from './banner.module.scss';
import classNames from 'classnames';
import { BANNER_TYPE } from 'src/constants/banner-type';

type BannerType = (typeof BANNER_TYPE)[keyof typeof BANNER_TYPE];

interface BannerProps {
  bannerType: BannerType;
}

export default function Banner({ children, bannerType }: PropsWithChildren<BannerProps>) {
  return (
    <div className={classNames(css.banner, css[bannerType])}>
      <div className={css.container}>
        <div className={css.textGroup}>{children}</div>
      </div>
    </div>
  );
}
